// Libraries
import type { salesCheckInMode, DeepLinks } from '@makemydeal/dr-sales-checkin-types';
import { SALES_CHECKIN_MODE } from '@makemydeal/dr-sales-checkin-ui-utils';
import type { CommonState } from './types/common';

export const getInitialCommonState = (): CommonState => ({
    globalSpinnerCount: 0,
    salesCheckInMode: (sessionStorage.getItem(SALES_CHECKIN_MODE) as salesCheckInMode) || undefined,
    navigateToPath: '',
    deeplinkUrls: new Map<DeepLinks, string>()
});
